import React from "react";
import { SelectFromReference } from "src/components/SelectFromReference";
import { makeFieldOptions } from "src/common/makeFieldOptions";
import { SelectProps } from "antd";
import { ZUid } from "src/types/zUid";
import { loadFilterAttributes } from "./loadFilterAttributes";

type PropsSelectFilter = SelectProps & {
  attributeId: ZUid;
};

export const SelectFilter: React.FC<PropsSelectFilter> = ({
  attributeId,
  ...props
}) => {
  const loader = React.useCallback(async () => {
    const res = await loadFilterAttributes(attributeId);
    return makeFieldOptions(res);
  }, [attributeId]);
  return (
    <SelectFromReference
      loader={loader}
      {...props}
      optionFilterProp="filterProp"
      showSearch
      allowClear
    />
  );
};
